import React, { useEffect, useState } from 'react'
import { useForm, Controller } from "react-hook-form"
import { Box, FormControlLabel, Radio, Button, Grid } from '@mui/material'
import { FeedbackWrapper, FormContainer, StyledRadioGroup } from '../StyledComponents'
import Input from './Input'
import { feedbackFormDefaults, feedbackFormFields } from '../data'
import CachedIcon from '@mui/icons-material/Cached';
import { IconButton } from '@material-ui/core'

const FormTypeRadio = ({ control }) => (
	<Controller
		control={control}
		name={'formType'}
		render={({ field }) => (
			<StyledRadioGroup
				row
				{...field}
				aria-labelledby="form-type"
			>
				<FormControlLabel value="feedback" control={<Radio />} label="Feedback" />
				<FormControlLabel value="complaint" control={<Radio />} label="Complaint" />
			</StyledRadioGroup>
		)}
	/>
)

function Feedback({ isTCP = false }) {
	const { control, handleSubmit, reset, formState: { isValid } } = useForm({ defaultValues: feedbackFormDefaults })
	const [captcha, setCaptcha] = useState('');
	const [captchaInput, setCaptchaInput] = useState('');
	const [isCaptchaValid, setIsCaptchaValid] = useState(false);
	const onSubmit = (data) => {
		console.info(data.formType, 'form submitted:', data)

		reset(defaultValues)
	}
	useEffect(() => {
		generateCaptcha();
	}, []);

	useEffect(() => {
		setIsCaptchaValid(captcha === captchaInput);
	}, [captcha, captchaInput]);

	const generateCaptcha = () => {
		const randomCaptcha = Math.floor(1000 + Math.random() * 9000).toString();
		setCaptcha(randomCaptcha);
		setCaptchaInput('');
	};

	return (
		<FeedbackWrapper className='feedbackForm'>
			<FormContainer className={isTCP ? 'tcp' : 'ud'}>
				<Box className="title">Feedback / Complaint</Box>
				<form className='formContent' onSubmit={handleSubmit(onSubmit)}>
					<Grid container rowSpacing={2} columnSpacing={4}>
						<Grid item xs={12}>
							<FormTypeRadio control={control} />
						</Grid>
						{feedbackFormFields.map(field => (
							<Grid
								item xs={12} key={field.name}
								lg={['mobileNo', 'email'].includes(field.name) ? 6 : 12}
							>
								<Input
									control={control}
									{...field}
								/>
							</Grid>
						))}

						<Grid item xs={12} lg={6}>
							<Input
								control={control}
								name={'captcha'}
								label="Captcha"
								placeholder="Enter Captcha"
								maxLength={4}
							/>
						</Grid>
						<Grid item xs={12} lg={6} container alignItems="center">
							<Box display="flex" alignItems="center">
								<Box mr={1}>Captcha: <span style={{color: 'black', fontStyle: 'italic', fontSize: '20px'}}>{captcha}</span></Box>
								<IconButton onClick={generateCaptcha}>
									<CachedIcon />
								</IconButton>
							</Box>
						</Grid>

						<Grid item xs={12}>
							<Button
								type='submit'
								variant='contained'
								color='warning'
								size='large'
								disabled={!isValid || !isCaptchaValid}
							>
								Submit
							</Button>
						</Grid>
					</Grid>
				</form>
			</FormContainer>
		</FeedbackWrapper>
	)
}

export default Feedback
